// Import images
import NexovaImg from "../src/Assets/images/nexova/2.png";
import PureSpaceImg from "../src/Assets/images/PureSpace/cover.png";
import GlowSkincare from "../src/Assets/images/Glow/cover.png";
import NexeraImg from "../src/Assets/images/Nexera/cover.png";
import LinkerPayImg from "../src/Assets/images/Linkerpay/cover.png";
import EcocycleImg from "../src/Assets/images/Ecocycle/cover.png";

// Project Data
export const projects = [
  {
    id: 1,
    name: "Nexova",
    client: "Nexova Technologies",
    image: NexovaImg,
    images: [NexovaImg, NexovaImg, NexovaImg, NexovaImg, NexovaImg],
    category: ["Brand Identity", "Social media"],
    description:
      "Nexova needed a bold new identity that could scale across digital and print platforms. We developed a modern, tech-inspired logo, a flexible brand system, and a vibrant social media design toolkit that elevated their presence and made them stand out in a competitive landscape.",
    website: "https://nexova.io",
    behance: "https://behance.net/nexova",
    year: 2024,
  },
  {
    id: 2,
    name: "PureSpace",
    client: "PureSpace Interiors",
    image: PureSpaceImg,
    images: [PureSpaceImg, PureSpaceImg, PureSpaceImg, PureSpaceImg, PureSpaceImg],
    category: ["Brand Identity", "Social media", "Web Development"],
    description:
      "PureSpace, a clean living and eco-interior brand, came to us needing a full-stack brand solution. We created a calming, minimal identity, consistent social content, and a clean, responsive website that reflects their core values of simplicity and sustainability.",
    website: "https://purespace.co",
    behance: "https://behance.net/purespace",
    year: 2023,
  },
  {
    id: 3,
    name: "Glow",
    client: "Glow Skincare",
    image: GlowSkincare,
    images: [GlowSkincare, GlowSkincare, GlowSkincare, GlowSkincare, GlowSkincare],
    category: ["Brand Identity", "Social media", "Web Development"],
    description:
      "Glow Skincare sought a complete brand refresh and ecommerce-ready website. We crafted a soft, feminine identity, built engaging content visuals, and developed a fast, mobile-optimized web experience with seamless shopping functionality.",
    website: "https://glowskincare.co",
    behance: "https://behance.net/glow",
    year: 2024,
  },
  {
    id: 4,
    name: "Nexera",
    client: "Nexera Cloud Systems",
    image: NexeraImg,
    images: [NexeraImg, NexeraImg, NexeraImg, NexeraImg, NexeraImg],
    category: ["Brand Identity", "Web Development"],
    description:
      "For Nexera’s SaaS product, we built a bold, scalable identity system and a powerful marketing website. The site is optimized for performance, conversion, and scalability, with custom CMS integration and conversion-optimized UX across devices.",
    website: "https://nexera.dev",
    behance: "https://behance.net/nexera",
    year: 2023,
  },
  {
    id: 5,
    name: "LinkerPay",
    client: "LinkerPay Inc.",
    image: LinkerPayImg,
    images: [LinkerPayImg, LinkerPayImg, LinkerPayImg, LinkerPayImg, LinkerPayImg],
    category: ["Brand Identity"],
    description:
      "LinkerPay needed a professional and secure brand identity for their digital payments platform. We created a clean, fintech-forward visual system, complete with a modern logo, color palette, and modular design assets suitable for onboarding, investor decks, and product visuals.",
    website: "https://linkerpay.com",
    behance: "https://behance.net/linkerpay",
    year: 2022,
  },
  {
    id: 6,
    name: "Ecocycle",
    client: "Ecocycle Solutions",
    image: EcocycleImg,
    images: [EcocycleImg, EcocycleImg, EcocycleImg, EcocycleImg, EcocycleImg],
    category: ["Brand Identity", "Product Design"],
    description:
      "Ecocycle, a green-tech startup, challenged us with crafting a unique identity that speaks to both innovation and sustainability. We developed an eco-conscious brand system and detailed product packaging designs that communicate their mission at every customer touchpoint.",
    website: "https://ecocycle.tech",
    behance: "https://behance.net/ecocycle",
    year: 2023,
  },
];

// Testimonials Data
export const testimonials = [
  {
    id: 1,
    name: "Leslie Alexander",
    businessName: "Leslie's Creations",
    review:
      "The team at Design Synergy did an amazing job on my website redesign. The process was seamless, and the result exceeded my expectations. Highly recommend!",
    image: "https://randomuser.me/api/portraits/women/1.jpg",
  },
  {
    id: 2,
    name: "Lindsay Walton",
    businessName: "Lindsay's Innovations",
    review:
      "Design Synergy provided exceptional service. They understood my vision and brought it to life beautifully. Their attention to detail was spot on.",
    image: "https://randomuser.me/api/portraits/women/2.jpg",
  },
  {
    id: 3,
    name: "Whitney Francis",
    businessName: "Whitney Designs",
    review:
      "I was blown away by the quality of work from Design Synergy. They took the time to understand my brand and delivered a design that truly represents my business.",
    image: "https://randomuser.me/api/portraits/women/3.jpg",
  },
  {
    id: 4,
    name: "Michael Foster",
    businessName: "Foster's Tech Solutions",
    review:
      "Design Synergy completely revamped my website and added features I didn't even know I needed. The team was professional and quick to respond.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
  },
  {
    id: 5,
    name: "Courtney Henry",
    businessName: "Courtney's Creative Studio",
    review:
      "Design Synergy delivered outstanding results. Their creativity and technical expertise were evident in every aspect of the project. A fantastic experience!",
    image: "https://randomuser.me/api/portraits/women/4.jpg",
  },
  {
    id: 6,
    name: "Leonard Krasner",
    businessName: "Krasner Digital",
    review:
      "Design Synergy helped me bring my online presence to the next level. The team was responsive, and the final product was exactly what I had envisioned.",
    image: "https://randomuser.me/api/portraits/men/2.jpg",
  },
  {
    id: 7,
    name: "Dries Vincent",
    businessName: "Vincent Creative Agency",
    review:
      "I couldn't be happier with the services provided by Design Synergy. They transformed my brand identity and made my website shine.",
    image: "https://randomuser.me/api/portraits/men/3.jpg",
  },
  {
    id: 8,
    name: "Tom Cook",
    businessName: "Cook Media Solutions",
    review:
      "Design Synergy went above and beyond in bringing my vision to life. The team was highly professional, and they delivered on time and within budget.",
    image: "https://randomuser.me/api/portraits/men/4.jpg",
  },
  {
    id: 9,
    name: "Floyd Miles",
    businessName: "Miles Design Studio",
    review:
      "Design Synergy is my go-to for all things design. They consistently provide high-quality work, and their customer service is top-notch. I couldn't ask for a better team.",
    image: "https://randomuser.me/api/portraits/men/5.jpg",
  },
];

// Brands Data
export const brands = [
  {
    alt: "Transistor",
    src: "https://tailwindcss.com/plus-assets/img/logos/158x48/transistor-logo-gray-900.svg",
  },
  {
    alt: "Reform",
    src: "https://tailwindcss.com/plus-assets/img/logos/158x48/reform-logo-gray-900.svg",
  },
  {
    alt: "Tuple",
    src: "https://tailwindcss.com/plus-assets/img/logos/158x48/tuple-logo-gray-900.svg",
  },
  {
    alt: "SavvyCal",
    src: "https://tailwindcss.com/plus-assets/img/logos/158x48/savvycal-logo-gray-900.svg",
  },
  {
    alt: "Statamic",
    src: "https://tailwindcss.com/plus-assets/img/logos/158x48/statamic-logo-gray-900.svg",
  },
];
